import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalConfirmation } from '@/lib/v2/organisms';

import {
  atomTotalSelectedRows
} from '@/modules/CampaignsModule/atoms/campaignRecurrentAtom';
import { atomToggleDeleteActionsModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { atomFiltersRecurrentAction, atomSelectedRecurrentActionsRowsWithID } from '@/modules/CampaignsModule/atoms/recurrentActionsAtom';
import { useRecurrentActionFilters } from '@/modules/CampaignsModule/hooks/useRecurrentActionFilters';
import { useRecurrentActions } from '@/modules/CampaignsModule/hooks/useRecurrentActions';
const DeleteRecurrentActions = () => {
  const { t } = useTranslation();
  const [toggleDeleteActionsModal, setToggleDeleteActionsModal] = useAtom(
    atomToggleDeleteActionsModal
  );

  const { deleteAction, loading } = useRecurrentActions();
  const { getActions } = useRecurrentActionFilters();
  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);
  const filtersRecurrentAction = useAtomValue(atomFiltersRecurrentAction);

  const actionsIdsToDelete = useAtomValue(atomSelectedRecurrentActionsRowsWithID);

  const handleConfirm = useCallback(async () => {
    await deleteAction(actionsIdsToDelete);
    setToggleDeleteActionsModal(false);
    await getActions({ ...filtersRecurrentAction });
  }, [deleteAction, actionsIdsToDelete, setToggleDeleteActionsModal, getActions, filtersRecurrentAction]);

  return (
    <ModalConfirmation
      isLoading={loading}
      isOpen={toggleDeleteActionsModal}
      textCancelButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.cancelButton')}
      textConfirmButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.successButton')}
      title={
        totalSelectedRows > 1
          ? t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.MULTIPLE.title')
          : t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.SINGLE.title')
      }
      onClose={setToggleDeleteActionsModal}
      onConfirmButton={handleConfirm}
    />
  );
};

export default DeleteRecurrentActions;
